import useMobileView from '../../../hooks/useMobileView';
import { AsideNavigationItem } from './AsideNavigationItem';
import { AsideNavigationItemType } from '../organisms/AsideNavigationBlock';
import { useLocation } from '@tanstack/react-router';
import { useState } from 'react';

export interface AsideNavigationSectionProps {
	item: AsideNavigationItemType;
	inheritNaviLevel: number;
	naviBlockIsOpen?: boolean;
}

export const AsideNavigationSection = ({
	item,
	inheritNaviLevel,
	naviBlockIsOpen,
}: AsideNavigationSectionProps) => {
	const location = useLocation();
	const currentLocation = location.pathname.replace(/\/$/, '');
	const isExpanded = currentLocation.includes(item.Url.replace(/\/$/, ''));
	const [naviSectionIsOpen, setNaviSectionIsOpen] = useState(isExpanded);

	const isMobile = useMobileView(900);
	const containerClassNames = `${isMobile && !naviBlockIsOpen ? 'hidden' : 'block'} ${isMobile ? 'divide-y divide-white' : ''}`;
	const navListClassNames = `${isMobile ? 'divide-y divide-white' : ''} ${naviSectionIsOpen ? 'block' : 'hidden'}`;

	return (
		<div className={containerClassNames}>
			<AsideNavigationItem
				item={item}
				itemLevel={inheritNaviLevel + 1}
				naviBlockIsOpen={naviBlockIsOpen}
				naviSectionIsOpen={naviSectionIsOpen}
				setNaviSectionIsOpen={setNaviSectionIsOpen}
			/>
			{naviSectionIsOpen ? (
				<ul className={navListClassNames}>
					{item.Children.map((children, index) => (
						<AsideNavigationSection
							key={`AsideNavigationItem -${inheritNaviLevel} -${index}`}
							item={children}
							inheritNaviLevel={inheritNaviLevel + 1}
							naviBlockIsOpen={naviBlockIsOpen}
						/>
					))}
				</ul>
			) : null}
		</div>
	);
};
